<template>
  <ion-loading :is-open="showLoading" message="Check metode pembayaran..." spinner="circles"></ion-loading>

  <ion-modal @didDismiss="onDidDismiss" :is-open="outletStore.showCartModal" @willDismiss="onWillDismiss"
    :initial-breakpoint="initialBreakpoint" :breakpoints="breakpoints" :expand-to-scroll="false" class="modern-modal">

    <ion-header class="ion-no-border modern-header">
      <ion-toolbar>
        <ion-title>Detail Pesanan</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <div class="order-container">
        <div v-for="(order, index) in orderList" :key="index" class="order-card-wrapper">
          <div v-if="order['qty'] > 0" class="modern-order-card">
            <div class="product-info">
              <div class="product-img-box">
                <img
                  :src="order['photo'] || 'https://res.cloudinary.com/dxcleuxwe/image/upload/v1758687442/placeholder/no-product-image_v7tdrr.png'" />
              </div>
              <div class="product-details">
                <h3>{{ order["product_name"] }}</h3>
                <p class="price-text">{{ formatter.format(order["qty"] * order["price"]) }}</p>
                
                <!-- Display Linked Menu Items -->
                <div v-if="order.link_menu && order.link_menu.length > 0" class="linked-items-list">
                  <div v-for="(group, gIdx) in order.link_menu" :key="gIdx">
                    <!-- Grouped OrderLinkMenu format -->
                    <template v-if="group.link_menu_detail && Array.isArray(group.link_menu_detail)">
                      <div v-for="(linkItem, lIdx) in group.link_menu_detail" :key="lIdx" class="linked-item-row">
                        <span class="linked-item-bullet">•</span>
                        <span class="linked-item-name">{{ linkItem.product_name }}</span>
                        <span class="linked-item-qty">x{{ order.qty }}</span>
                        <span class="linked-item-price" v-if="linkItem.price_add > 0">
                          (+{{ formatter.format(order.qty * linkItem.price_add) }})
                        </span>
                        <span class="linked-item-price free" v-else>(Gratis)</span>
                      </div>
                    </template>
                    <template v-else>
                      <!-- Flat legacy fallback -->
                      <div class="linked-item-row">
                        <span class="linked-item-bullet">•</span>
                        <span class="linked-item-name">{{ group.product_name }}</span>
                        <span class="linked-item-qty">x{{ (group.qty || 1) * order.qty }}</span>
                        <span class="linked-item-price" v-if="group.price > 0">
                          (+{{ formatter.format((group.qty || 1) * order.qty * group.price) }})
                        </span>
                        <span class="linked-item-price free" v-else>(Gratis)</span>
                      </div>
                    </template>
                  </div>
                </div>

                <div v-if="order['note']" class="note-badge">
                  <ion-icon :icon="createOutline" class="mini-icon"></ion-icon>
                  {{ order["note"] }}
                </div>
              </div>
            </div>

            <div class="order-controls">
              <ion-button @click="openNoteModal(index)" fill="clear" class="btn-note" color="medium">
                <ion-icon :icon="createOutline" class="note-icon"></ion-icon>
                <span class="note-label">{{ order["note"] ? 'Ubah catatan' : 'Tambah catatan' }}</span>
              </ion-button>

              <div class="qty-stepper">
                <button @click="reduced(order['product_detail_id'])" class="stepper-btn">-</button>
                <span class="stepper-val">{{ result(order["product_detail_id"]) }}</span>
                <button @click="add(order['product_detail_id'])" class="stepper-btn">+</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ion-content>

    <div class="ion-no-border modern-footer">
      <div class="tax-section">
        <div v-for="(tax, key, i) in taxs()" :key="i" class="tax-row">
          <span>{{ key }}</span>
          <span>{{ formatter.format(taxPerItem(tax)) }}</span>
        </div>
      </div>

      <div class="footer-summary">
        <div class="total-box">
          <span class="label">Total Pembayaran</span>
          <span class="amount">{{ formatter.format(sum(orderList)) }}</span>
        </div>
        <ion-button expand="block" class="main-order-btn" @click="handlePaymentOptions">
          Konfirmasi Pesanan
        </ion-button>
      </div>
    </div>
  </ion-modal>

  <ion-modal :is-open="isOpen" class="note-edit-modal" @willDismiss="closeNoteModal">
    <div class="modal-content">
      <h3>Tambah Catatan</h3>
      <p>Misal: Tidak pakai sambal, atau es dikit saja.</p>
      <ion-textarea fill="outline" :value="editingNote" @input="editingNote = $event.target.value"
        placeholder="Tulis catatan di sini..." rows="4"></ion-textarea>
      <div class="modal-actions">
        <ion-button fill="clear" color="medium" @click="closeNoteModal">Batal</ion-button>
        <ion-button @click="saveNote" color="danger" class="save-btn">Simpan</ion-button>
      </div>
    </div>
  </ion-modal>
  <insufficient-stock-modal
    :is-open="showStockModal"
    :items="outOfStockItems"
    @close="showStockModal = false"
    @edit-order="handleEditOrder"
  />
</template>

<script>
import { useOutletStore } from "@/stores/outlet"
import { IonModal, IonHeader, IonToolbar, IonButton, IonContent, IonLoading, IonTitle, IonIcon, IonTextarea, alertController } from "@ionic/vue";

import { createOutline } from "ionicons/icons";
import { storage } from "../utils/storage";
import InsufficientStockModal from "./insufficientStockModal.vue";

export default {
  name: "outletCheckOrder",
  props: ["orderList", "editID"],
  components: { IonModal, IonHeader, IonToolbar, IonButton, IonContent, IonLoading, IonTitle, IonIcon, IonTextarea, InsufficientStockModal },
  data() {
    return {
      showLoading: false,
      createOutline,
      isOpen: false,
      editingIndex: null,
      editingNote: "",
      formatter: new Intl.NumberFormat("ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 2,
      }),
      hiden: false,
      order_code: "",
      qrcode: "",
      timeout: 5000,
      showStockModal: false,
      outOfStockItems: [],
      groupTax: {},
    };
  },
  computed: {
    outletStore() {
      return useOutletStore()
    },
    isEmptyCart() {
      return this.orderList.length === 0 ||
        this.orderList.every(item => item.qty === 0);
    },
    initialBreakpoint() {
      const activeItemsCount = this.orderList ? this.orderList.filter(item => item.qty > 0).length : 0;
      return activeItemsCount > 2 ? 0.85 : 0.5;
    },
    breakpoints() {
      const activeItemsCount = this.orderList ? this.orderList.filter(item => item.qty > 0).length : 0;
      return activeItemsCount > 2 ? [0, 0.85, 1] : [0, 0.5, 0.85, 1];
    }
  },
  mounted() {
    const store = useOutletStore()
    if (this.orderList) {
      store.setOrderList(this.orderList);
    }
    if (this.editID) {
      store.setEditId(this.editID)
    }
  },
  watch: {
    isEmptyCart: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.outletStore.showCartModal) {
          // Tutup modal jika cart kosong
          setTimeout(() => {
            this.outletStore.setShowCartModal(false);
          }, 100);
        }
      }
    }
  },
  methods: {
    onWillDismiss() {
      this.outletStore.setShowCartModal(false)
    },
    onDidDismiss() {
      // Ubah state setelah modal benar-benar tertutup
      this.outletStore.setShowCartModal(false);
    },
    openNoteModal(index) {
      this.editingIndex = index;
      this.editingNote = this.orderList[index].note || ""; // ambil note saat ini
      this.isOpen = true;
    },
    closeNoteModal() {
      this.isOpen = false;
      this.editingIndex = null;
      this.editingNote = "";
    },
    saveNote() {
      if (this.editingIndex !== null) {
        this.orderList[this.editingIndex].note = this.editingNote;

        this.$emit("changeListOrder", this.orderList);
      }
      this.closeNoteModal();
    },
    taxs() {
      let allTax = [];
      for (let i = 0; i < this.orderList.length; i++) {
        const item = this.orderList[i];
        if (item.qty <= 0) continue;

        // Parent
        if (item.tax && item.tax.length != 0) {
          for (let j = 0; j < item.tax.length; j++) {
            allTax.push({
              order_qty: item.qty,
              price: item.price,
              tax_name: item.tax[j].name,
              tax_amount: item.tax[j].jumlah,
            });
          }
        }

        // Child (link menu)
        const extraSource = item.link_menu || item.extra;
        if (extraSource && extraSource.length > 0) {
          for (let k = 0; k < extraSource.length; k++) {
            const entry = extraSource[k];
            if (entry.link_menu_detail && Array.isArray(entry.link_menu_detail)) {
              for (let d = 0; d < entry.link_menu_detail.length; d++) {
                const child = entry.link_menu_detail[d];
                if (child.tax && child.tax.length != 0) {
                  for (let j = 0; j < child.tax.length; j++) {
                    allTax.push({
                      order_qty: item.qty,
                      price: child.price_add || 0,
                      tax_name: child.tax[j].name,
                      tax_amount: child.tax[j].jumlah,
                    });
                  }
                }
              }
            } else {
              // Legacy flat format fallback
              const child = entry;
              if (child.tax && child.tax.length != 0) {
                for (let j = 0; j < child.tax.length; j++) {
                  allTax.push({
                    order_qty: item.qty * (child.qty || 1),
                    price: child.price || 0,
                    tax_name: child.tax[j].name,
                    tax_amount: child.tax[j].jumlah,
                  });
                }
              }
            }
          }
        }
      }

      let groupTax = allTax.reduce((k, v) => {
        k[v.tax_name] = [...(k[v.tax_name] || []), v];
        return k;
      }, {});
      return groupTax;
    },
    hide(hiden) {
      this.$emit("hider", hiden);
    },
    sum(o) {
      let t = [];
      let sum = 0;
      for (let i = 0; i < o.length; i++) {
        const item = o[i];
        if (item.qty <= 0) continue;

        // Parent
        if (item.tax && item.tax.length != 0) {
          for (let j = 0; j < item.tax.length; j++) {
            if (item.tax.length > 1) {
              if (item.tax[j].jumlah > 100) {
                t.push(item.tax[j].jumlah);
              } else {
                t.push(
                  item.qty *
                  this.priceIncludeTax(item.price, item.tax[j].jumlah)
                );
              }
            } else {
              if (item.tax[j].jumlah > 100) {
                t.push(item.price * item.qty + item.tax[j].jumlah);
              } else {
                t.push(
                  item.qty *
                  this.priceIncludeTax(item.price, item.tax[j].jumlah)
                );
              }
            }
          }
        } else {
          t.push(item.qty * item.price);
        }

        // Child (link menu)
        const extraSource = item.link_menu || item.extra;
        if (extraSource && extraSource.length > 0) {
          for (let k = 0; k < extraSource.length; k++) {
            const entry = extraSource[k];
            if (entry.link_menu_detail && Array.isArray(entry.link_menu_detail)) {
              for (let d = 0; d < entry.link_menu_detail.length; d++) {
                const child = entry.link_menu_detail[d];
                const childQty = item.qty;
                const priceAdd = child.price_add || 0;
                if (child.tax && child.tax.length != 0) {
                  for (let j = 0; j < child.tax.length; j++) {
                    if (child.tax.length > 1) {
                      if (child.tax[j].jumlah > 100) {
                        t.push(child.tax[j].jumlah);
                      } else {
                        t.push(
                          childQty *
                          this.priceIncludeTax(priceAdd, child.tax[j].jumlah)
                        );
                      }
                    } else {
                      if (child.tax[j].jumlah > 100) {
                        t.push(priceAdd * childQty + child.tax[j].jumlah);
                      } else {
                        t.push(
                          childQty *
                          this.priceIncludeTax(priceAdd, child.tax[j].jumlah)
                        );
                      }
                    }
                  }
                } else {
                  t.push(childQty * priceAdd);
                }
              }
            } else {
              // Legacy flat format fallback
              const child = entry;
              const childQty = item.qty * (child.qty || 1);
              const price = child.price || 0;
              if (child.tax && child.tax.length != 0) {
                for (let j = 0; j < child.tax.length; j++) {
                  if (child.tax.length > 1) {
                    if (child.tax[j].jumlah > 100) {
                      t.push(child.tax[j].jumlah);
                    } else {
                      t.push(
                        childQty *
                        this.priceIncludeTax(price, child.tax[j].jumlah)
                      );
                    }
                  } else {
                    if (child.tax[j].jumlah > 100) {
                      t.push(price * childQty + child.tax[j].jumlah);
                    } else {
                      t.push(
                        childQty *
                        this.priceIncludeTax(price, child.tax[j].jumlah)
                      );
                    }
                  }
                }
              } else {
                t.push(childQty * price);
              }
            }
          }
        }
      }
      for (let a = 0; a < t.length; a++) {
        sum += t[a];
      }
      // prmbulatan
      return Math.ceil(sum / 100) * 100 ;
    },
    add(prodDetailId) {
      for (let i = 0; i < this.orderList.length; i++) {
        if (this.orderList[i]["product_detail_id"] == prodDetailId) {
          if (this.orderList[i]["qty"]) {
            this.orderList[i]["qty"] += 1;
          }
        }
      }
      this.$emit("changeListOrder", this.orderList);
    },
    reduced(prodDetailId) {
      for (let i = 0; i < this.orderList.length; i++) {
        if (this.orderList[i]["product_detail_id"] == prodDetailId) {
          if (this.orderList[i]["qty"]) {
            this.orderList[i]["qty"] -= 1;

            if (this.orderList[i]["qty"] == 0) {
              this.orderList.splice(i, 1);

              // Emit perubahan terlebih dahulu
              this.$emit("changeListOrder", this.orderList);

              // Tunggu DOM update
              this.$nextTick(() => {
                if (this.orderList.length == 0) {
                  // Tutup modal dengan timeout
                  setTimeout(() => {
                    this.outletStore.setShowCartModal(false);
                  }, 50);
                }
              });
              return; // Keluar dari method
            }
          }
        }
      }
      this.$emit("changeListOrder", this.orderList);
    },
    // reduced(prodDetailId) {
    //   for (let i = 0; i < this.orderList.length; i++) {
    //     if (this.orderList[i]["product_detail_id"] == prodDetailId) {
    //       if (this.orderList[i]["qty"]) {
    //         this.orderList[i]["qty"] -= 1;
    //         if (this.orderList[i]["qty"] == 0) {
    //           this.orderList.splice(i, 1);
    //         }
    //       }
    //     }
    //   }
    //   this.$emit("changeListOrder", this.orderList);
    //   if (this.orderList.length == 0) {
    //     this.outletStore.setShowCartModal(false)
    //   }
    // },
    result(prodDetailId) {
      if (this.orderList.length) {
        // console.log(this.product);
        for (let i = 0; i < this.orderList.length; i++) {
          if (this.orderList[i].product_detail_id == prodDetailId) {
            return this.orderList[i].qty;
          }
        }
      }
    },
    taxPerItem(tax) {
      let t = 0;
      let tx = 0;
      let txPrice = 0;
      for (let i = 0; i < tax.length; i++) {
        if (tax[i].tax_amount > 100) {
          t = tax[i].tax_amount;
        } else {
          tx = tax[i].tax_amount * tax[i].order_qty;
          txPrice = (tax[i].price * tx) / 100;
          t += txPrice;
        }
      }
      return t;
      // let t = 0;
      // if (tax.tax_amount > 100) {
      //   t = tax.tax_amount;
      //   return t;
      // } else {
      //   let tx = tax.tax_amount * tax.order_qty;
      //   t = (price * tx) / 100;
      //   return t;
      // }
    },
    priceIncludeTax(price, tax) {
      let total = 0;
      let t = (price * tax) / 100;
      total = price + t;
      return total;
    },
    async handlePaymentOptions() {
      this.showLoading = true

      try {
        const myHeaders = new Headers();
        myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}=`);

        const requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow",
        };

        const url = `${process.env.VUE_APP_BASE_URL}v1/transaction/order-online-setting?outlet_id=${this.$route.params.id}`;

        const res = await fetch(url, requestOptions);

        if (res.status === 200) {
          const data = await res.json();
          const dinein = data.data.order_type.dinein;

          if (dinein === "on") {
            this.outletStore.setOrder(false);
            this.outletStore.setshowPaymentOptionDialog(true);
          } else {
            await this.deals(this.outletStore.orderList);
          }
        } else {
          await this.showErrorAlert('Gagal memuat pengaturan toko. Silakan coba lagi.');
        }
      } catch (error) {
        console.error("Error checking payment options:", error);
        await this.showErrorAlert('Koneksi internet terputus atau tidak stabil. Silakan periksa koneksi Anda.');
      } finally {
        this.showLoading = false;
      }
    },
    getInsufficientStockItems(insufficientStockObj, orderList = []) {
      if (!insufficientStockObj || typeof insufficientStockObj !== "object") {
        return [];
      }

      const ids = Object.keys(insufficientStockObj);
      const items = [];

      ids.forEach(id => {
        let found = null;

        if (Array.isArray(orderList)) {
          for (const item of orderList) {
            if (item.product_detail_id == id || item.product_id == id) {
              found = {
                id,
                name: item.product_name || item.name,
                photo: item.photo || item.image || ""
              };
              break;
            }
            const extraSource = item.link_menu || item.extra;
            if (extraSource && Array.isArray(extraSource)) {
              for (const group of extraSource) {
                const details = group.link_menu_detail || [group];
                if (Array.isArray(details)) {
                  for (const detail of details) {
                    if (detail.product_detail_fkid == id || detail.product_detail_id == id) {
                      found = {
                        id,
                        name: detail.product_name || detail.name,
                        photo: detail.photo || ""
                      };
                      break;
                    }
                  }
                }
                if (found) break;
              }
            }
            if (found) break;
          }
        }

        items.push(found || { id, name: `Produk (ID: ${id})`, photo: "" });
      });

      return items;
    },
    handleEditOrder() {
      this.showStockModal = false;
    },
    async createOrder() {
      let myHeaders = new Headers();
      myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}=`);
      let id = parseInt(this.$route.params.id);
      let order = this.outletStore.orderList;
      let raw;
      let url = "";
      let method = "";
      console.log(this.editID);
      if (this.editID !== "0" && this.editID !== "") {
        raw = JSON.stringify({ order_list: order });
        url = `v1/transaction/self_order/${this.editID}`;
        method = "PUT";
      } else {
        raw = JSON.stringify({ outlet_id: id, order_list: order });
        url = "v1/transaction/self_order";
        method = "POST";
      }

      let requestOptions = {
        method: method,
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      try {
        let res = await fetch(
          `${process.env.VUE_APP_BASE_URL}${url}`,
          requestOptions
        );
        let data = await res.json().catch(() => null);

        if (res.status === 200 && data && data.status !== false && data["data"]?.["order_code"]) {
          let order_code = data["data"]["order_code"],
            qrcode = data["data"]["qrcode"],
            expired = data["data"]["expired"];

          let date = new Date(expired);
          let hours = date.getHours(),
            minutes = date.getMinutes();

          this.$emit("orderData", order_code, qrcode, hours, minutes);
          storage.setHistoryOrder(
            JSON.stringify({
              outlet_id: id,
              items: order,
              trans: {
                order_code,
                qrcode,
                expired,
              },
            })
          );
        } else {
          const insufficientStockObj = data?.data?.insufficient_stock || data?.insufficient_stock;
          if (insufficientStockObj && Object.keys(insufficientStockObj).length > 0) {
            this.outOfStockItems = this.getInsufficientStockItems(insufficientStockObj, order);
            this.showStockModal = true;
          } else {
            await this.showErrorAlert(data?.message || 'Gagal membuat pesanan. Silakan coba lagi.');
          }
        }
      } catch (error) {
        console.error("Error creating order:", error);
        await this.showErrorAlert('Gagal membuat pesanan karena masalah koneksi. Silakan periksa internet Anda.');
      }
    },
    async deals(order) {
      let myHeaders = new Headers();
      myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}=`);
      let id = parseInt(this.$route.params.id);
      let raw;
      let url = "";
      let method = "";
      console.log(this.editID);
      if (this.editID !== "0" && this.editID !== "") {
        raw = JSON.stringify({ order_list: order });
        url = `v1/transaction/self_order/${this.editID}`;
        method = "PUT";
      } else {
        raw = JSON.stringify({ outlet_id: id, order_list: order });
        url = "v1/transaction/self_order";
        method = "POST";
      }

      let requestOptions = {
        method: method,
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      try {
        let res = await fetch(
          `${process.env.VUE_APP_BASE_URL}${url}`,
          requestOptions
        );
        if (res.status === 200) {
          let data = await res.json();
          let order_code = data["data"]["order_code"],
            qrcode = data["data"]["qrcode"],
            expired = data["data"]["expired"];

          let date = new Date(expired);
          let hours = date.getHours(),
            minutes = date.getMinutes();

          this.$emit("orderData", order_code, qrcode, hours, minutes);
          storage.setHistoryOrder(
            JSON.stringify({
              outlet_id: id,
              items: order,
              trans: {
                order_code,
                qrcode,
                expired,
              },
            })
          );
        } else {
          await this.showErrorAlert('Gagal membuat pesanan. Silakan coba lagi.');
        }
      } catch (error) {
        console.error("Error creating order:", error);
        await this.showErrorAlert('Gagal membuat pesanan karena masalah koneksi. Silakan periksa internet Anda.');
      }
    },
    async showErrorAlert(message) {
      const alert = await alertController.create({
        header: 'Koneksi Gagal',
        message: message,
        buttons: ['OK'],
      });
      await alert.present();
    },
  },
};
</script>

<style scoped>
/* Modal Setup */
.modern-header ion-title {
  font-weight: 700;
  font-size: 1.1rem;
  text-align: center;
}

/* Card Container */
.order-card-wrapper {
  margin-bottom: 12px;
}

.modern-order-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid #f0f0f0;
}

.product-info {
  display: flex;
  gap: 12px;
  align-items: center;
}

.product-img-box img {
  width: 65px;
  height: 65px;
  border-radius: 12px;
  object-fit: cover;
}

.product-details h3 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #333;
}

.price-text {
  margin: 4px 0;
  font-weight: 700;
  color: var(--primary-color, #8C1115);
  font-size: 0.9rem;
}

.note-badge {
  font-size: 0.75rem;
  color: #666;
  background: #f5f5f5;
  padding: 4px 8px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Quantity Stepper */
.order-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px dashed #eee;
  padding-top: 10px;
}

.qty-stepper {
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border-radius: 30px;
  padding: 4px;
}

.stepper-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: white;
  color: var(--primary-color, #8C1115);
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.stepper-val {
  padding: 0 12px;
  font-weight: 700;
  font-size: 0.9rem;
}

/* Footer Section */
.modern-footer {
  background: #ffffff;
  /* Bayangan halus di atas footer untuk efek 'elevation' */
  box-shadow: 0 -10px 25px rgba(0, 0, 0, 0.08);
  padding: 16px 20px calc(16px + var(--ion-safe-area-bottom));
}

.footer-inner {
  display: flex;
  flex-direction: column;
}

.tax-section {
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #eee;
}

.tax-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: #777;
  margin-bottom: 2px;
}

.footer-summary {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.total-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.total-box .label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #444;
}

.total-box .amount {
  font-size: 1.25rem;
  font-weight: 800;
  color: var(--primary-color, #8C1115);
  /* Warna Brand */
}

.main-order-btn {
  --background: var(--primary-color, #8C1115);
  --border-radius: 14px;
  --box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin: 0;
  height: 52px;
  font-weight: 700;
  font-size: 1rem;
  text-transform: none;
}

/* Tambahan: Pastikan ion-content tidak tertutup footer */
ion-content {
  --background: #f8f9fa;
}

.order-card-wrapper {
  margin-bottom: 12px;
}

.modern-order-card {
  background: white;
  border-radius: 16px;
  padding: 14px;
  border: 1px solid #f0f0f0;
}

/* Note Modal */
.note-edit-modal {
  --height: auto;
  --border-radius: 20px;
  align-items: flex-end;
}

.modal-content {
  padding: 24px;
  background: white;
}

.modal-content h3 {
  margin: 0 0 8px 0;
  font-weight: 700;
}

.modal-content p {
  font-size: 0.85rem;
  color: #777;
  margin-bottom: 16px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}

.save-btn {
  --border-radius: 8px;
  min-width: 100px;
}

/* Linked Items Styling */
.linked-items-list {
  margin-top: 8px;
  background: #f8f9fa;
  padding: 8px 12px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  border: 1px solid #edf2f7;
}

.linked-item-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  color: #4a5568;
}

.linked-item-bullet {
  color: var(--primary-color, #8C1115);
  font-weight: bold;
}

.linked-item-name {
  font-weight: 500;
}

.linked-item-qty {
  color: #718096;
  margin-left: auto;
  font-weight: 600;
}

.linked-item-price {
  font-weight: 600;
  color: #2d3436;
}

.linked-item-price.free {
  color: #2f855a;
  font-weight: bold;
}

/* Note Button & Label Styling */
.btn-note {
  --padding-start: 4px;
  --padding-end: 8px;
  --height: 32px;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #718096;
}

.note-icon {
  font-size: 0.95rem;
  margin: 0;
}

.note-label {
  font-size: 0.75rem;
  font-weight: 400;
  font-style: italic;
  text-transform: none;
  color: #718096;
}
</style>